import { RESPONSE_CODES } from "core/constants/responseCodes";

export const isResponseSuccess = data => {
    return data.resultCode === RESPONSE_CODES.Success
}